import { createContext } from 'react'

import { UseFormMethods } from 'react-hook-form'
import { TGetValidateMessageInstance } from '@utils/validation/getValidateMessageInstance'
import { TGetValidateStatusInstance } from '@utils/validation/getValidateStatusInstance'
import { TValidatorRules } from '@utils/validation/Validator/Validator'

export type CFormContextState = Pick<
  UseFormMethods<any>,
  'control' | 'reset' | 'setError' | 'setValue' | 'getValues' | 'clearErrors' | 'trigger' | 'watch'
> & {
  rules: TValidatorRules<any>
  status: ReturnType<TGetValidateStatusInstance>
  mess: ReturnType<TGetValidateMessageInstance>
  formId: string
}

const CFormContext = createContext({} as CFormContextState)

export default CFormContext
